import React from 'react';

const PRLoader = () => {
  return (
    <div className="flex flex--column u-gap-1 pr-loader u-w-5 u-h-4 relative">
      {[1,2,3].map((index) => (
        <div className={"pr-loader__item u-gap-05 flex flex--center absolute u-left-0 u-w-full pr-loader__item--" + index} key={index}>
          <div className="pr-loader__block bg-white"></div>
          <div className="flex flex--column flex--center flex--top flex--1">
            <div className="pr-loader__line pr-loader__line--1 bg-white"></div>
            <div className="pr-loader__line pr-loader__line--2 bg-white"></div>
          </div>
        </div>
      ))}
    </div>
  )
};

export default PRLoader
